import { setFavoriteRequest, dropFavoriteSongRequest } from "./songs";
const baseUrl = "https://laravel-47muwp.chabk.ir";
// const baseUrl = "http://127.0.0.1:8000";

const createPlayListOnServer = (playListName) => {
  const fd = new FormData();
  fd.append("playListName", playListName);
  return fetch(baseUrl + "/playlists", {
    method: "post",
    body: fd,
    credentials: "include",
  }).then((res) => res.json());
};
const getPlayLists = () => {
  return fetch(`${baseUrl}/playlists`, {
    credentials: "include",
  }).then((res) => res.json());
};
const getTracksOfTheWeek = (page = 1) => {
  return fetch(`${baseUrl}/tracks-of-the-week?page=${page}`).then((res) => {
    console.log("tracks fetch", res);
    return res.json();
  });
};
const appendSongToPlaylist = (songId, playListName) => {
  const fd = new FormData();
  fd.append("songId", songId);
  fd.append("playListName", playListName);
  return fetch(`${baseUrl}/playlists/push`, {
    method: "post",
    credentials: "include",
    body: fd,
  }).then((res) => res.json());
};
//exports
export {
  createPlayListOnServer,
  getPlayLists,
  getTracksOfTheWeek,
  setFavoriteRequest,
  dropFavoriteSongRequest,
  baseUrl,
  appendSongToPlaylist,
};
